import { MutationTree } from 'vuex'
import { PromotionsState, Mutations } from './types'

const mutations: MutationTree<PromotionsState> = {
  [Mutations.SET_IS_PROMO_CODE_VALID](state, value: boolean) {
    state.isPromoCodeValid = value
  },
}

export default mutations
